var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"report-order-lines"},[_c('ul',{staticClass:"order-line-list"},_vm._l((_vm.orderModule.orderLines),function(orderLine){return _c('StageReportOrderLine',{key:orderLine.id,attrs:{"order-line":orderLine,"model-value":_vm.assignmentModule.serialNumberForOrderLine(orderLine)},on:{"input":function($event){return _vm.onUpdateSerialNumber({
          id: orderLine.id,
          serialNumber: $event,
        })}}})}),1)])}
var staticRenderFns = []

export { render, staticRenderFns }